/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![NewUserSimpleIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABtUlEQVR4nN1Uu0olYQwe1MYbW4monRdsVhsf4FSCMpPLEWLi8SxY2W4lKIjHxsIHsBBUfAFLQRsL38BGVOwURZBlvW6n8qsrwzAzZ+ZoZeCD4U/4viSTxPO+rQHYIJLtAtstkF4h2xqidRaLkx3u2705n4shKg3kIkeUfiB7RLbnCM6B9Czm/QFAerMLkG3FkDyngnQze3vIjnMLsB5kF2DbzysAbHvZW8S6UIPAXPYKwNqB7G+O9vwZEWnLLPAqQjqVI/uyV4sh63IGgaWayEMiv5HtKYb4CUgXva8wYCsj6/1HS8juiLSUm2h4uNzMXBp6g/YUCoWG/z5/bKIPWLdfEdraSqVS5/vS5Y+Vuh1E5EdypmSnke38B6TrjiAa+36TVsOVvVd3mijgxi3+DNhl+KD5xfGfQHoRO1Gk18kVsO6kjOJREARNItIIZIfJcbqdJhBUWagFZJtPiwlYRxMF3trk+pqQHdmdQ0oCK141E5F6d1fSiSxKfIOsM26iqgp8VILYimgIrNMB6S9g2wj9jw23G86HRfNFpMX7rAHbXCjj2U8TRs0tHpKeOLiF+nKBWu0FNpnR6nxpx4sAAAAASUVORK5CYII=)
 */
export const NewUserSimpleIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M11.33 13.68c.41.27.93.27 1.34 0 1.73-1.1 6.2-4.3 6.2-8.02 0-2.02-1.6-3.66-3.59-3.66-1.46 0-2.42.58-3.28 1.44A4.33 4.33 0 0 0 8.72 2a3.63 3.63 0 0 0-3.6 3.66c0 3.72 4.48 6.92 6.2 8.02Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M3.93 13.84a.94.94 0 0 0-.93.94 5.6 5.6 0 0 0 6.48 5.6l1.02-.18v1.27c0 .85.67 1.53 1.5 1.53s1.5-.68 1.5-1.53V20.2l1.02.17A5.6 5.6 0 0 0 21 14.78a.94.94 0 0 0-.93-.94h-2.24a5.6 5.6 0 0 0-4.89 2.9L12 18.41l-.94-1.69a5.6 5.6 0 0 0-4.89-2.9H3.93Z"
        className={colorClass}
      />
    </svg>
  );
};
